import env from '../util/env.js'
import RetailOrderView from './RetailOrderView'
import RetailOrderVerticalView from './RetailOrderVerticalView'
import React from 'react'
export default function () {
    const isVertical = env.verticalTouch();
    if (isVertical) {
        return <RetailOrderVerticalView></RetailOrderVerticalView>
    } else {
        return <RetailOrderView></RetailOrderView>
    }
}